import ScrollFadeIn from "./Scrollfadein";
import { useIsMobile } from "./Useismobile";

export default function ContactCTA({ theme }) {
  const { fg, muted, border, accent } = theme;
  const isMobile = useIsMobile();

  return (
    <section style={{ padding: isMobile ? "60px 20px 80px" : "80px 40px 100px", maxWidth: 1200, margin: "0 auto" }}>
      <ScrollFadeIn>
        <div style={{ height: 1, background: border, marginBottom: isMobile ? 28 : 40 }} />
        <p style={{ fontSize: 10, letterSpacing: "0.2em", color: muted, marginBottom: isMobile ? 20 : 28 }}>
          LET'S BUILD SOMETHING TOGETHER
        </p>
        <h2 style={{
          fontFamily: "'Bebas Neue', sans-serif",
          fontSize: isMobile ? "clamp(48px, 16vw, 80px)" : "clamp(52px, 11vw, 140px)",
          fontWeight: 400,
          lineHeight: 0.93,
          letterSpacing: "0.01em",
          color: fg,
        }}>
          WANNA<br />
          COLLABORATE?<br />
          <a
            href="mailto:olarindedavid49@gmail.com"
            style={{ color: accent, textDecoration: "none", transition: "opacity 0.2s", display: "inline-block" }}
            onMouseEnter={e => e.currentTarget.style.opacity = "0.65"}
            onMouseLeave={e => e.currentTarget.style.opacity = "1"}
          >
            REACH OUT.
          </a>
        </h2>

        {/* On mobile, also show email as a tappable button */}
        {isMobile && (
          <a
            href="mailto:olarindedavid49@gmail.com"
            style={{
              display: "inline-block",
              marginTop: 32,
              padding: "14px 28px",
              fontSize: 11, letterSpacing: "0.16em",
              border: `1px solid ${fg}`, borderRadius: 100,
              background: fg, color: theme.bg,
              textDecoration: "none",
            }}
          >
            SEND AN EMAIL ↗
          </a>
        )}
      </ScrollFadeIn>
    </section>
  );
}